import { css, cx } from '@emotion/css'
import { theme } from '../styles/theme.js'

const styles = {
  base: css({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing.sm,
    padding: `${theme.spacing.md} ${theme.spacing.lg}`,
    fontSize: theme.typography.fontSize.base,
    fontWeight: 600,
    borderRadius: theme.radii.md,
    border: 'none',
    transition: 'all 0.15s ease',
    minHeight: '48px',
    minWidth: '48px',
    '&:active': {
      transform: 'scale(0.985)',
    },
  }),
  primary: css({
    backgroundColor: theme.colors.primary,
    color: '#fff',
    '&:hover': {
      backgroundColor: theme.colors.primaryHover,
    },
  }),
  secondary: css({
    backgroundColor: theme.colors.surfaceElevated,
    color: theme.colors.text,
    border: `1px solid ${theme.colors.border}`,
    '&:hover': {
      backgroundColor: theme.colors.surface,
    },
  }),
  ghost: css({
    backgroundColor: 'transparent',
    color: theme.colors.text,
    '&:hover': {
      backgroundColor: theme.colors.surfaceElevated,
    },
  }),
  fullWidth: css({
    width: '100%',
  }),
}

const Button = ({ variant = 'primary', fullWidth = false, className, children, ...props }) => {
  const variantStyle = styles[variant] || styles.primary
  const combined = cx(
    styles.base,
    variantStyle,
    fullWidth && styles.fullWidth,
    className
  )

  return (
    <button className={combined} {...props}>
      {children}
    </button>
  )
}

export { Button }
